import React from 'react';
import { Box, styled } from '@mui/material';

const DashboardContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.grey[100],
  minHeight: '100vh',
}));

export default DashboardContainer;